export default __webpack_public_path__ + "static/media/failed.157422f0.png";